export default {
  CryptoBalance: "Crypto Balances",
  Displayedcurrencies: "Displayed currencies",
};
